import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './NotFound.css';

const NotFound = () => (
  <>
    <Helmet>
      <title>404 — Page Not Found | BloodBridge</title>
      <meta name="robots" content="noindex" />
    </Helmet>
    <div className="notfound-page">
      <div className="nf-content">
        <div className="nf-art">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="0.5" width="120" height="120" className="animate-float">
            <path d="M12 2C12 2 5 9.5 5 14a7 7 0 0 0 14 0C19 9.5 12 2 12 2z"/>
          </svg>
        </div>
        <div className="nf-code">404</div>
        <h1>Page Not Found</h1>
        <p>The page you're looking for doesn't exist or has been moved. Let's get you back on track.</p>
        <div className="nf-actions">
          <Link to="/" className="btn btn-primary">Back to Home</Link>
          <Link to="/contact" className="btn btn-outline">Contact Us</Link>
        </div>
      </div>
    </div>
  </>
);

export default NotFound;
